import CpfCard from "./components/cpf/cpf-card.jsx";
import CnpjCard from "./components/cnpj/cnpj-card.jsx";
import SosActivationsCard from "./components/sos-activations/sos-activations-card.jsx";

export default function GeneralView({ general }) {
    return (
        <>
            <CpfCard data={general} />
            <CnpjCard data={general} />
            <SosActivationsCard data={general} />
        </>
    )
}
